import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ConfigApi } from '../shared/config-api.model';
import { ConfigUrlProvider } from '../shared/configurl-provider';

@Injectable()
export class LoginServico {

    private sub: any;
    configApi: ConfigApi;

    constructor(private http: Http,
        private httpClient: HttpClient,
        private router: Router,
        private configUrlProvider: ConfigUrlProvider) {
        this.configApi = this.configUrlProvider.getConfigApi()
        this.loadConfig();
    }

    login(usuario: string, senha: string) {
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });

        //return this.http.post("http://localhost:62195/api/Login/Autenticar", JSON.stringify({ usuario: usuario, senha: senha }), options)
        return this.http.post(this.sub + "/api/Login/Autenticar", JSON.stringify({ usuario: usuario, senha: senha }), options)
            .map((response: Response) => {
                let dados = response.json()[0];
                if (dados && dados.token) {
                    alert("oi");
                    //console.log(dados.token);
                    //localStorage.setItem('Token', JSON.stringify(dados.token));
                    localStorage.setItem('AcessoAdm', JSON.stringify(dados));
                }
            });
    }

    logout() {
        localStorage.removeItem('AcessoAdm');
        this.router.navigate(['login']);
    }

    private loadConfig() {
        this.sub = this.configApi.webApiUrl;
    }
}


// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/servicos/login.servico.ts